import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class PersonApi {

    static getAllPerson = async (response, error) => {
        await Api.get(`${configs.persons}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static insertPerson = async (data, response, error) => {
        await Api.post(`${configs.persons}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deletePerson = async (id, response, error) => {
        await Api.delete(`${configs.persons}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }
}